var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaciColectori(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_513_56)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_513_56",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 10L9.83827 5.49026C9.46331 4.82366 9.94502 4 10.7098 4H20.7902C21.555 4 22.0367 4.82366 21.6617 5.49026L19.125 10"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.5034 10.4903C11.7742 10.9716 12.3839 11.1423 12.8653 10.8716C13.3466 10.6008 13.5173 9.9911 13.2466 9.50974L11.5034 10.4903ZM18.2534 9.50974C17.9827 9.9911 18.1534 10.6008 18.6347 10.8716C19.1161 11.1423 19.7258 10.9716 19.9966 10.4903L18.2534 9.50974ZM13.2466 9.50974L10.7098 5L8.9667 5.98052L11.5034 10.4903L13.2466 9.50974ZM10.7098 5H20.7902V3H10.7098V5ZM20.7902 5L18.2534 9.50974L19.9966 10.4903L22.5333 5.98052L20.7902 5ZM20.7902 5L20.7902 5L22.5333 5.98052C23.2832 4.64731 22.3198 3 20.7902 3V5ZM10.7098 5L10.7098 5V3C9.18019 3 8.21677 4.64732 8.9667 5.98052L10.7098 5Z",
    fill: "#161616",
    mask: "url(#path-1-inside-1_513_56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7158 10.5H18.7842C18.8203 10.5387 18.8626 10.5845 18.9108 10.637C19.0854 10.8275 19.3357 11.1059 19.6366 11.4556C20.2387 12.1557 21.0408 13.1387 21.8417 14.2714C22.6437 15.4056 23.438 16.6808 24.0303 17.9657C24.6251 19.2561 25 20.522 25 21.6471C25 23.1492 24.4467 24.5828 23.0608 25.6554C21.6576 26.7413 19.3452 27.5 15.75 27.5C12.1548 27.5 9.84238 26.7413 8.43924 25.6554C7.05333 24.5828 6.5 23.1492 6.5 21.6471C6.5 20.522 6.87489 19.2561 7.46971 17.9657C8.06196 16.6808 8.85629 15.4056 9.65825 14.2714C10.4592 13.1387 11.2613 12.1557 11.8634 11.4556C12.1643 11.1059 12.4146 10.8275 12.5892 10.637C12.6374 10.5845 12.6797 10.5387 12.7158 10.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16H20",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19H20",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22H20",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_513_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 24,
    fill: "white",
    transform: "translate(6 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaciColectori);
export default __webpack_public_path__ + "static/media/SaciColectori.f4945e5689261c1aef1e31eaf918df85.svg";
export { ForwardRef as ReactComponent };